"use strict";
var base_1 = require("@bhtp-client-api/base");
var country_view_model_1 = require("./country-view.model");
var TripDetailsViewModel = (function () {
    function TripDetailsViewModel() {
    }
    TripDetailsViewModel.fromPolicyResponse = function (source) {
        var target = new TripDetailsViewModel();
        if (source.policy) {
            // This is the text version of the country name (Used to display on header)
            target.destination = source.policy.destination;
            // This is the iso 2 code of the country (used for trip details and quoting)
            target.destinationCountry = source.policy.destinationCountry;
            target.destinationCity = source.policy.destinationCity;
            target.destinationState = source.policy.destinationState;
            target.departureDate = source.policy.departureDates.localized.dateString;
            target.returnDate = source.policy.returnDates.localized.dateString;
            // Trip Suppliers
            target.airline = source.policy.airline;
            target.airlineNotProvided = !source.policy.airline;
            target.carRentalCompany = source.policy.carRentalCompany;
            target.cruise = source.policy.cruiseLine;
            target.hotel = source.policy.hotel;
            target.rentalCompany = source.policy.rentalCompany;
            target.tourOperator = source.policy.tourOperator;
        }
        return target;
    };
    TripDetailsViewModel.toApiPolicy = function (source, target) {
        if (!target) {
            target = new base_1.ApiPolicy();
        }
        if (source) {
            if (source.destinationCountry instanceof country_view_model_1.CountryViewModel) {
                target.destinationCountry = source.destinationCountry.isoCode2;
            }
            target.destinationCity = source.destinationCity;
            target.destinationState = source.destinationState;
            // Setup return and departure dates
            var departureDate = new base_1.DateInformation();
            var returnDate = new base_1.DateInformation();
            departureDate.localized = new base_1.DateParts();
            returnDate.localized = new base_1.DateParts();
            departureDate.localized.fullDateTime = source.departureDate;
            returnDate.localized.fullDateTime = source.returnDate;
            target.returnDates = returnDate;
            target.departureDates = departureDate;
            // Trip Suppliers
            target.airline = source.airline;
            target.carRentalCompany = source.carRentalCompany;
            target.cruiseLine = source.cruise;
            target.hotel = source.hotel;
            target.rentalCompany = source.rentalCompany;
            target.tourOperator = source.tourOperator;
        }
        return target;
    };
    return TripDetailsViewModel;
}());
exports.TripDetailsViewModel = TripDetailsViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/trip-details-view.model.js